import React from 'react';
import Content from '../Components/Content'
import TabStrip  from '../Components/TabStrip';

class StaticPage extends React.Component {
    render() {
        return (
            <div>
                <Content contentKey={this.props.params.id} secure={true} />       
                <TabStrip activeTab={29} /> 
            </div>
        );
    }
};
export default StaticPage;


// WEBPACK FOOTER //
// ./src/Pages/Static.js